'use client'

import Link from 'next/link'
import { useRouter } from 'next/router'
import { cn } from '@/lib/utils'
import { DOCS_NAV } from '@/constants/docs-nav'

/* Docs side navigation, grouped like the Figma file. Used in the desktop sidebar and the phone menu. */
export function DocsSidebarNav({ onNavigate, className }: { onNavigate?: () => void, className?: string }) {
    const router = useRouter()
    const path = router.asPath.split('#')[0].split('?')[0]

    return (
        <nav aria-label='Docs' className={cn('flex flex-col gap-6', className)}>
            {DOCS_NAV.map(group => (
                <div key={group.title} className='flex flex-col gap-1'>
                    <h4 className='px-2 pb-1 text-xs font-medium text-text-secondary'>
                        {group.title}
                    </h4>
                    {group.items.map(item => {
                        const active = path === item.href

                        return (
                            <Link
                                key={item.href}
                                href={item.href}
                                onClick={onNavigate}
                                aria-current={active ? 'page' : undefined}
                                className={cn(
                                    'flex h-8 items-center rounded-md px-2 text-sm transition-colors outline-none focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-border-focus',
                                    active ? 'bg-surface-muted font-medium text-text-primary' : 'text-text-secondary hover:bg-surface-subtle hover:text-text-primary'
                                )}
                            >
                                <span className='truncate'>
                                    {item.title}
                                </span>
                            </Link>
                        )
                    })}
                </div>
            ))}
        </nav>
    )
}
